function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.155 27.675l-7.711 3.428a1.11 1.11 0 01-.45.096c-.057 0-.236-.025-.236-.025L6.251 24.4c-.502-.112-.885-.54-.885-1.076 0-.458.275-.85.67-1.025l20.26-9.006c.137-.061.288-.096.448-.096.057 0 .236.025.236.025l18.564 3.991M19.776 52.06l17.984 3.867s.178.025.236.025c.16 0 .31-.035.449-.096l20.26-9.007c.394-.173.67-.565.67-1.023v-6.188"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.366 23.323v24.754c0 .536.383.964.885 1.076l6.761 1.454M37.996 55.953V31.199M34.377 23.928l-9.883 4.394v4.006c0 .714-.66 1.247-1.358 1.097l-4.507-.97a1.122 1.122 0 01-.886-1.096V26.87l23.705-10.538M38.972 21.886l-1.92.853M54.873 41.18l7.265-3.23M30.443 47.333l1.636-.728M10.1 56.345l17.537-7.764M35.746 7.482l7.425-3.287M40.809 10.946l2.813-1.364m15.752-7.638L48.122 7.4M1 56.246l6.37-2.832"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.874 32.324C60.466 32.324 65 27.79 65 22.197c0-5.592-4.534-10.126-10.126-10.126-5.593 0-10.127 4.534-10.127 10.126 0 5.593 4.534 10.127 10.127 10.127z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.81 22.197l3.376 3.038 3.376-3.038 3.375-3.038",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.374 35.137V31.2",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgBoxFinish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/box-finish.svg";
export { SvgBoxFinish as ReactComponent };